<!-- Header Section -->
<header class="header">
  <div class="logo">Kiko VPN</div>
  <nav class="navigation">
      <a href="/home">Home</a>
      <a href="/downloads">Downloads</a>
      <a href="/privacy">Privacy</a>
      <a href="/terms">Terms</a>
      <a href="/reseller">Reseller</a>
      <a href="/faq">Faq</a>
      <a href="/support">Support</a>
      <a href="/about">About Us</a>
  </nav>
</header>

<div class="downloads-container">
    <div class="downloads-header">
      <h1>Download Our VPN App</h1>
      <p>Choose your platform to download the app and start using our VPN service today!</p>
    </div>
  
    <div class="downloads-buttons">
      <div class="download-item">
        <img src="assets/icons/icon_android_os.png" alt="Android" class="platform-icon" />
        <a href="https://www.kikovpn.com/download/KikoVPN.apk" class="download-btn" target="_blank" onclick="androidDownloaded()">
          Download for Android
        </a>
      </div>
  
      <div class="download-item">
        <img src="assets/icons/icon_iphone_os.png" alt="iOS" class="platform-icon" />
        <a href="https://www.kikovpn.com/download/KikoVPN.ipa" class="download-btn" target="_blank" onclick="iosDownloaded()">
          Download for iOS
        </a>
      </div>
  
      <div class="download-item">
        <img src="assets/icons/icon_windows_os.png" alt="Windows" class="platform-icon" />
        <a href="https://www.kikovpn.com/download/KikoVPNSetup.exe" class="download-btn" target="_blank" onclick="winDownloaded()">
          Download for Windows
        </a>
      </div>
  
      <div class="download-item">
        <img src="assets/icons/icon_mac_os.png" alt="macOS" class="platform-icon" />
        <a href="https://www.kikovpn.com/download/KikoVPNSetup.dmg" class="download-btn" target="_blank" onclick="macDownloaded()">
          Download for macOS
        </a>
      </div>
    </div>
  </div>